import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X, Star, Shield, Clock, Lock, CreditCard, ChevronDown, ArrowRight, FileText, Zap, MapPin, TrendingUp, Package, AlertCircle } from 'lucide-react';
// --- DATA ARRAYS ---
const TESTIMONIALS_HERO = [{
  initials: 'MG',
  name: 'Marcos G.',
  loc: 'Buenos Aires',
  text: 'Arranqué con el Tomo 1 un sábado. El domingo siguiente ya tenía mis primeros 10 pedidos confirmados. El sistema funciona.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  loc: 'Rosario',
  text: 'El Tomo 3 me salvó la vida. Antes vendía sin saber si ganaba o perdía. Ahora sé exactamente cuánto me cuesta cada burger y cuánto gano.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  loc: 'Córdoba',
  text: 'Pensé que era solo recetas. Es un sistema completo de negocio. Llevo 3 meses vendiendo y el cupo se llena todos los viernes.'
}];
const PAIN_POINTS = ['Comprás carne sin saber el blend correcto y la burger no tiene el sabor esperado.', 'Ponés precios por intuición y no entendés por qué trabajás tanto y ganás poco.', 'El primer viernes de alta demanda colapsás por falta de un sistema de producción.', 'No sabés cómo fotografiar tus burgers y el menú no atrae clientes.', 'Querés vender pero te faltan las palabras para comunicar el valor de tu producto.', 'Fin de semana agotado, el lunes volvés a empezar el mismo ciclo sin avanzar.'];
const TOMOS = [{
  id: 1,
  color: 'border-blue-500',
  title: 'La Base',
  subtitle: 'Infraestructura Hogareña',
  desc: 'Equipamiento, espacio de trabajo y adaptación profesional del hogar. Seguridad e higiene doméstica.'
}, {
  id: 2,
  color: 'border-orange-500',
  title: 'El Alquimista',
  subtitle: 'Ingeniería de Menú',
  desc: 'Los mejores blends para Argentina. Pan Kalis, queso Milkaut y salsas firma. Smash vs medallón clásico.'
}, {
  id: 3,
  color: 'border-red-500',
  title: 'El Contador',
  subtitle: 'Costos e Inflación',
  desc: 'Fichas técnicas, cálculo de margen real y actualización de precios. Manejo de proveedores y planillas.'
}, {
  id: 4,
  color: 'border-emerald-500',
  title: 'El Operador',
  subtitle: 'Producción en Serie',
  desc: 'Mise en place profesional. Sistema de producción escalonada y gestión del servicio de alta demanda.'
}, {
  id: 5,
  color: 'border-amber-500',
  title: 'El Vendedor',
  subtitle: 'Marketing de Barrio',
  desc: 'Instagram gastronómico, fotografía con celular y scripts de WhatsApp. Promociones que funcionan.'
}, {
  id: 6,
  color: 'border-cyan-600',
  title: 'El Dueño',
  subtitle: 'Delivery y Escalado',
  desc: 'Packaging térmico, logística de reparto y marco legal argentino. Estrategia de escalado inteligente.'
}];
const BONOS = [{
  id: 1,
  title: 'Kit Express de Arranque en 72 Horas',
  desc: 'De cero a tu primer pedido real en 3 días con un plan simple.',
  value: '$8.000'
}, {
  id: 2,
  title: 'Menú Mínimo Ganador',
  desc: 'Cómo armar un menú corto, vendible y rentable. 100 nombres incluidos.',
  value: '$10.000'
}, {
  id: 3,
  title: 'Checklist Maestro de Producción',
  desc: 'Checklists de apertura, servicio y cierre listos para imprimir.',
  value: '$9.000'
}, {
  id: 4,
  title: 'Pack de Copy para Vender',
  desc: '100 nombres, 50 descripciones y scripts listos para copiar y pegar.',
  value: '$8.000'
}, {
  id: 5,
  title: '20 Promociones de Lanzamiento',
  desc: 'Sistema de promos inteligentes para arrancar sin destruir el margen.',
  value: '$9.000'
}, {
  id: 6,
  title: 'Guía de Errores que te Hacen Perder Plata',
  desc: '30 módulos con los errores más comunes y sus soluciones exactas.',
  value: '$9.000'
}];
const COMPARISON = [{
  sit: 'Actualización de precios',
  sin: 'Improvisás y perdés margen',
  con: 'Sistema con alertas de inflación'
}, {
  sit: 'Implementación de delivery',
  sin: 'Logística improvisada',
  con: 'Protocolo profesional paso a paso'
}, {
  sit: 'Gestión de alta demanda',
  sin: 'Perdés clientes por falta de cupo',
  con: 'Sistema de lista de espera VIP'
}, {
  sit: 'Contratación de personal',
  sin: 'Trabajás solo al límite',
  con: 'Guía de primer empleado'
}, {
  sit: 'Formalización del negocio',
  sin: 'Trámites postergados',
  con: 'Roadmap legal y fiscal completo'
}, {
  sit: 'Apertura de local propio',
  sin: 'Decisiones sin información',
  con: 'Calculadora de punto de equilibrio'
}];
const TESTIMONIALS_MORE = [{
  init: 'CR',
  name: 'Cecilia R.',
  loc: 'Mendoza',
  pack: 'MegaPack Pro',
  text: 'El Tomo 3 me cambió la vida. Ahora tengo fichas técnicas de cada burger y sé exactamente qué gano.'
}, {
  init: 'RM',
  name: 'Roberto M.',
  loc: 'Buenos Aires',
  pack: 'MegaPack Completo',
  text: 'El sistema de mise en place convirtió mi cocina en una línea de producción. Paso de 15 a 40 burgers por noche.'
}, {
  init: 'SC',
  name: 'Sofía C.',
  loc: 'La Plata',
  pack: 'MegaPack Completo',
  text: 'Los scripts de WhatsApp casi duplicaron mi tasa de conversión de consultas a pedidos.'
}, {
  init: 'PA',
  name: 'Pablo A.',
  loc: 'Neuquén',
  pack: 'MegaPack Pro',
  text: 'El sistema de blend fue un antes y un después. Mis burgers tienen una costra y sabor únicos en el barrio.'
}, {
  init: 'VT',
  name: 'Valeria T.',
  loc: 'Rosario',
  pack: 'MegaPack Completo',
  text: 'El Kit de 72 Horas me obligó a arrancar. Tres días después tenía mi primer pedido real.'
}, {
  init: 'JM',
  name: 'Julián M.',
  loc: 'Córdoba',
  pack: 'MegaPack Pro',
  text: 'El Tomo 5 me enseñó a fotografiar con el celular. El cupo se llenó en 2 horas el siguiente fin de semana.'
}];
const FAQS = [{
  q: '¿Sirve si nunca hice hamburguesas antes?',
  a: 'Sí. El sistema está diseñado para emprendedores desde cero. El Tomo 1 empieza por el equipamiento mínimo y el Bono 1 te guía en las primeras 72 horas.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en PDF. Al confirmar el pago recibís el acceso inmediato en tu email. Podés leerlo desde cualquier dispositivo.'
}, {
  q: '¿Qué lo diferencia de recetas de YouTube?',
  a: 'YouTube te da recetas. Nosotros te damos un sistema de negocio: costos, fichas técnicas, producción, ventas y escalado. Es la diferencia entre cocinar y emprender.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas. Nuestra tasa de devoluciones es menor al 1%.'
}, {
  q: '¿Los insumos se consiguen en Argentina?',
  a: 'Todo está construido sobre insumos reales del mercado argentino (Pan Kalis, Queso Milkaut, cortes de carnicería de barrio). No hay ingredientes importados difíciles de conseguir.'
}, {
  q: '¿Sirve si ya tengo una hamburguesería funcionando?',
  a: 'Sí, especialmente los tomos de costos, producción en volumen y escalado. Muchos emprendedores lo usan para profesionalizar su negocio actual.'
}];
const COST_INACTION = [{
  sin: 'Precios puestos por intuición',
  costo: 'Miles de pesos de ganancia perdida'
}, {
  sin: 'Producción sin sistema',
  costo: 'Horas de caos en cada servicio'
}, {
  sin: 'Fotos de baja calidad',
  costo: 'Clientes que no te eligen'
}, {
  sin: 'Sin scripts de venta',
  costo: 'Consultas que no convierten'
}, {
  sin: 'Insumos mal comprados',
  costo: 'Burgers sin identidad'
}, {
  sin: 'Fin de semana agotado',
  costo: 'El mismo ciclo sin avanzar'
}];
// --- COMPONENTS ---
const ButtonCTA = ({
  children,
  href = '#pricing',
  variant = 'primary',
  className = ''
}: any) => {
  const baseStyle = 'inline-flex items-center justify-center font-medium tracking-wide text-lg py-4 px-8 rounded-xl transition-all duration-200 w-full md:w-auto text-center shadow-sm hover:shadow-md hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-brand-accent text-white hover:bg-brand-accent/90',
    orange: 'bg-brand-orange text-white hover:bg-brand-orange/90',
    gold: 'bg-brand-gold text-white hover:bg-brand-gold/90',
    outline: 'bg-transparent border border-brand-espresso text-brand-espresso hover:bg-brand-espresso/5'
  };
  return <a href={href} className={`${baseStyle} ${variants[variant as keyof typeof variants]} ${className}`} data-id="element-2">
      {children}
    </a>;
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-3 font-display text-2xl md:text-3xl text-brand-espresso my-6" data-id="element-3">
      <div className="bg-white border border-stone-200 shadow-sm rounded-lg w-16 h-16 flex flex-col items-center justify-center" data-id="element-4">
        <span data-id="element-5">{String(timeLeft.h).padStart(2, '0')}</span>
        <span className="text-[10px] font-sans text-stone-500 uppercase tracking-wider" data-id="element-6">
          Horas
        </span>
      </div>
      <span className="text-stone-300 pb-4" data-id="element-7">:</span>
      <div className="bg-white border border-stone-200 shadow-sm rounded-lg w-16 h-16 flex flex-col items-center justify-center" data-id="element-8">
        <span data-id="element-9">{String(timeLeft.m).padStart(2, '0')}</span>
        <span className="text-[10px] font-sans text-stone-500 uppercase tracking-wider" data-id="element-10">
          Min
        </span>
      </div>
      <span className="text-stone-300 pb-4" data-id="element-11">:</span>
      <div className="bg-white border border-stone-200 shadow-sm rounded-lg w-16 h-16 flex flex-col items-center justify-center" data-id="element-12">
        <span className="text-brand-orange" data-id="element-13">
          {String(timeLeft.s).padStart(2, '0')}
        </span>
        <span className="text-[10px] font-sans text-stone-500 uppercase tracking-wider" data-id="element-14">
          Seg
        </span>
      </div>
    </div>;
};
const FAQItem = ({
  q,
  a
}: {
  q: string;
  a: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="mb-3 border border-stone-200 rounded-xl bg-white shadow-sm overflow-hidden" data-id="element-15">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left font-semibold text-brand-espresso hover:bg-stone-50 transition-colors" data-id="element-16">
        <span data-id="element-17">{q}</span>
        <ChevronDown className={`text-stone-400 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-18" />
      </button>
      <AnimatePresence data-id="element-19">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="px-5 pb-5 text-stone-600 leading-relaxed text-sm" data-id="element-20">
            {a}
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function LandingPage() {
  return <div className="min-h-screen font-sans selection:bg-brand-orange/20 selection:text-brand-espresso overflow-x-hidden bg-brand-cream" data-id="element-21">
      {/* HERO SECTION */}
      <section className="bg-brand-cream pt-16 pb-24 px-4 relative" data-id="element-22">
        <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-23">
          <div className="text-left order-2 lg:order-1" data-id="element-24">
            <div className="mb-6" data-id="element-25">
              <span className="inline-flex items-center gap-2 bg-brand-orange/10 border border-brand-orange/20 text-brand-orange px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-26">
                Master Burger Argentina™
              </span>
            </div>

            <h1 className="md:text-5xl lg:text-6xl font-display mb-6 text-brand-espresso text-[28px]" data-id="element-27">
              Todo lo que necesitás para arrancar tu{' '}
              <span className="text-brand-orange" data-id="element-28">hamburguesería casera.</span>
            </h1>

            <p className="text-stone-600 mb-8 font-light text-[14px]" data-id="element-29">
              El sistema integral para emprendedores gastronómicos en Argentina.
              Recetas, costos, operación y ventas listos para usar. Sin
              improvisar.
            </p>

            <div className="flex flex-wrap gap-3 mb-10" data-id="element-30">
              {[{
              icon: FileText,
              text: '100% Digital'
            }, {
              icon: Zap,
              text: 'Acceso Inmediato'
            }, {
              icon: MapPin,
              text: 'Adaptado a Argentina'
            }, {
              icon: Package,
              text: '6 Tomos Completos'
            }].map((badge, i) => <div key={i} className="flex items-center gap-2 bg-white border border-stone-200 px-3 py-1.5 rounded-lg text-xs font-medium text-stone-600 shadow-sm" data-id="element-31">
                  <badge.icon size={14} className="text-brand-orange" data-id="element-32" />
                  {badge.text}
                </div>)}
            </div>

            <div data-id="element-33">
              <ButtonCTA href="#pricing" variant="orange" className="text-lg py-4 px-10 font-semibold shadow-lg shadow-brand-orange/20" data-id="element-34">
                QUIERO MI MASTER BURGER AHORA
              </ButtonCTA>

              <div className="flex items-center gap-5 mt-5 text-xs text-stone-500 font-medium uppercase tracking-wider" data-id="element-35">
                <span className="flex items-center gap-1.5" data-id="element-36">
                  <Shield size={14} className="text-brand-gold" data-id="element-37" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1.5" data-id="element-38">
                  <Lock size={14} className="text-brand-gold" data-id="element-39" /> Pago seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-40">
                  <CreditCard size={14} className="text-brand-gold" data-id="element-41" /> Mercado
                  Pago
                </span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-42">
            <img src="https://cdn.magicpatterns.com/uploads/p5Qv2zArjfoWstD8u3QPZ5/Master_Burger.png" alt="Master Burger Argentina - El Pack Más Completo con 6 Tomos" className="w-full max-w-md lg:max-w-lg drop-shadow-2xl object-contain" data-id="element-43" />
          </div>
        </div>
      </section>

      {/* STATS BAR */}
      <section className="bg-white border-y border-stone-200 py-8 px-4" data-id="element-44">
        <div className="max-w-5xl mx-auto flex flex-wrap justify-center md:justify-between items-center gap-8 text-center" data-id="element-45">
          <div data-id="element-46">
            <span className="block text-3xl font-display text-brand-espresso mb-1" data-id="element-47">
              +500
            </span>
            <span className="text-xs text-stone-500 uppercase tracking-wider font-medium" data-id="element-48">
              Emprendedores
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-stone-200" data-id="element-49"></div>
          <div data-id="element-50">
            <span className="block text-3xl font-display text-brand-espresso mb-1" data-id="element-51">
              6
            </span>
            <span className="text-xs text-stone-500 uppercase tracking-wider font-medium" data-id="element-52">
              Tomos Listos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-stone-200" data-id="element-53"></div>
          <div data-id="element-54">
            <span className="block text-3xl font-display text-brand-espresso mb-1" data-id="element-55">
              6
            </span>
            <span className="text-xs text-stone-500 uppercase tracking-wider font-medium" data-id="element-56">
              Bonos Incluidos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-stone-200" data-id="element-57"></div>
          <div data-id="element-58">
            <span className="block text-3xl font-display text-brand-espresso mb-1" data-id="element-59">
              4.9/5
            </span>
            <span className="text-xs text-stone-500 uppercase tracking-wider font-medium" data-id="element-60">
              Calificación Media
            </span>
          </div>
        </div>
      </section>

      {/* HERO TESTIMONIALS */}
      <section className="py-20 px-4 max-w-5xl mx-auto" data-id="element-61">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-62">
          {TESTIMONIALS_HERO.map((t, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} key={i} className="bg-white border border-stone-200 p-8 rounded-2xl shadow-sm" data-id="element-63">
              <div className="flex text-brand-gold mb-4" data-id="element-64">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-65" />)}
              </div>
              <p className="text-stone-600 font-medium mb-6 leading-relaxed text-sm" data-id="element-66">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-67">
                <div className="w-10 h-10 bg-brand-cream text-brand-espresso rounded-full flex items-center justify-center font-display text-sm" data-id="element-68">
                  {t.initials}
                </div>
                <div data-id="element-69">
                  <p className="font-semibold text-brand-espresso text-sm" data-id="element-70">
                    {t.name}
                  </p>
                  <p className="text-[11px] text-stone-400 uppercase tracking-wider" data-id="element-71">
                    {t.loc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="py-24 px-4 bg-white border-y border-stone-200" data-id="element-72">
        <div className="max-w-3xl mx-auto" data-id="element-73">
          <h2 className="text-3xl md:text-4xl font-display text-center mb-6 text-brand-espresso" data-id="element-74">
            ¿Cuántos fines de semana más vas a seguir improvisando?
          </h2>
          <p className="text-lg text-center text-stone-500 mb-12 font-light leading-relaxed" data-id="element-75">
            Querés emprender con hamburguesas. Sabés que hay demanda. Pero nadie
            te dijo que ibas a pasar los domingos sin saber qué comprar, cuánto
            cobrar o cómo organizar la producción.{' '}
            <span className="font-medium text-brand-espresso" data-id="element-76">
              No es falta de ganas. Es falta de un sistema.
            </span>
          </p>

          <div className="space-y-3 mb-16" data-id="element-77">
            {PAIN_POINTS.map((point, i) => <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} key={i} className="flex items-start gap-4 bg-brand-cream/50 border border-stone-100 p-5 rounded-xl" data-id="element-78">
                <div className="text-brand-accent mt-0.5" data-id="element-79">
                  <X size={20} strokeWidth={2.5} data-id="element-80" />
                </div>
                <p className="font-medium text-stone-700" data-id="element-81">{point}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-82">
            <h3 className="text-xl font-display text-brand-espresso" data-id="element-83">
              ¿Y si este fuera el último fin de semana que pasás así?
            </h3>
          </div>
        </div>
      </section>

      {/* THE SOLUTION - TOMOS */}
      <section className="py-24 px-4 bg-stone-50" data-id="element-84">
        <div className="max-w-5xl mx-auto" data-id="element-85">
          <div className="text-center mb-16" data-id="element-86">
            <span className="text-brand-orange text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-87">
              De Cero a Negocio Consolidado
            </span>
            <h2 className="text-3xl md:text-5xl font-display mb-4 text-brand-espresso" data-id="element-88">
              El MegaPack Completo
            </h2>
            <p className="text-lg font-light text-stone-500" data-id="element-89">
              6 Tomos + 6 Bonos. Todo resuelto.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-90">
            {TOMOS.map((tomo, i) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={tomo.id} className={`bg-white border border-stone-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all border-l-4 ${tomo.color}`} data-id="element-91">
                <span className="text-stone-400 text-xs font-bold tracking-widest uppercase mb-2 block" data-id="element-92">
                  Tomo {tomo.id}
                </span>
                <h3 className="text-xl font-display mb-1 text-brand-espresso" data-id="element-93">
                  {tomo.title}
                </h3>
                <p className="text-brand-orange text-sm font-medium mb-4" data-id="element-94">
                  {tomo.subtitle}
                </p>
                <p className="text-stone-600 text-sm leading-relaxed font-light" data-id="element-95">
                  {tomo.desc}
                </p>
              </motion.div>)}
          </div>

          <div className="mt-16 bg-white border border-stone-200 rounded-2xl p-8 max-w-3xl mx-auto shadow-sm" data-id="element-96">
            <h4 className="text-sm font-bold tracking-widest uppercase text-center mb-8 text-brand-espresso" data-id="element-97">
              El sistema incluye
            </h4>
            <div className="grid md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-98">
              {['Paso a paso adaptado al mercado argentino', 'Insumos conseguibles en cualquier barrio', 'Fichas técnicas listas para completar', 'Criterios de selección de proveedores', 'Checklists de producción y servicio', 'Estrategias para economía inflacionaria', 'Scripts de venta para WhatsApp', 'Adaptado al emprendedor doméstico'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                  <Check className="text-brand-orange flex-shrink-0 mt-0.5" size={16} data-id="element-100" />
                  <span className="text-stone-600 text-sm font-light" data-id="element-101">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* THE BONUSES */}
      <section className="py-24 px-4 bg-brand-cream relative border-y border-stone-200" data-id="element-102">
        <div className="max-w-5xl mx-auto" data-id="element-103">
          <div className="text-center mb-16" data-id="element-104">
            <h2 className="text-3xl md:text-4xl font-display text-brand-espresso mb-4" data-id="element-105">
              6 Bonos Estratégicos
            </h2>
            <p className="text-brand-accent font-semibold tracking-wide uppercase text-sm" data-id="element-106">
              Siempre incluidos con tu acceso
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-107">
            {BONOS.map((bono, i) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} key={bono.id} className="bg-white border border-stone-200 rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-108">
                <span className="text-brand-gold text-xs font-bold tracking-widest uppercase mb-2 block" data-id="element-109">
                  Bono {bono.id}
                </span>
                <h3 className="text-lg font-semibold text-brand-espresso mb-3 leading-tight" data-id="element-110">
                  {bono.title}
                </h3>
                <p className="text-stone-500 text-sm font-light mb-6 flex-grow" data-id="element-111">
                  {bono.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-stone-100" data-id="element-112">
                  <span className="text-stone-400 line-through text-sm" data-id="element-113">
                    {bono.value}
                  </span>
                  <span className="text-brand-accent font-bold text-sm uppercase tracking-wider" data-id="element-114">
                    Gratis
                  </span>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-16 text-center" data-id="element-115">
            <div className="inline-block bg-white border border-stone-200 py-6 px-10 rounded-2xl shadow-sm" data-id="element-116">
              <p className="text-xs text-stone-500 font-bold uppercase tracking-widest mb-2" data-id="element-117">
                Valor total en bonos
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-118">
                <span className="line-through text-stone-400 text-2xl font-light" data-id="element-119">
                  $53.000
                </span>
                <ArrowRight className="text-stone-300" size={20} data-id="element-120" />
                <span className="text-brand-orange font-display text-3xl" data-id="element-121">
                  GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="py-24 px-4 bg-white border-b border-stone-200" data-id="element-122">
        <div className="max-w-5xl mx-auto" data-id="element-123">
          <div className="text-center mb-16" data-id="element-124">
            <div className="inline-flex items-center gap-2 text-brand-accent font-semibold text-sm uppercase tracking-wider mb-2" data-id="element-125">
              <Clock size={16} data-id="element-126" /> Precio de Lanzamiento
            </div>
            <CountdownTimer data-id="element-127" />
            <p className="text-stone-500 text-sm flex items-center justify-center gap-1.5 mt-2" data-id="element-128">
              <AlertCircle size={14} data-id="element-129" /> El precio se actualizará pronto.
            </p>

            <div className="max-w-xs mx-auto mt-8" data-id="element-130">
              <div className="flex justify-between text-xs font-semibold text-stone-500 uppercase tracking-wider mb-2" data-id="element-131">
                <span data-id="element-132">Cupos disponibles</span>
                <span className="text-brand-espresso" data-id="element-133">Pocos</span>
              </div>
              <div className="w-full bg-stone-100 rounded-full h-2 overflow-hidden" data-id="element-134">
                <div className="bg-brand-orange h-2 rounded-full" style={{
                width: '82%'
              }} data-id="element-135"></div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-136">
            {/* Standard Pack */}
            <div className="bg-white border border-stone-200 rounded-3xl p-8 shadow-sm flex flex-col" data-id="element-137">
              <h3 className="text-xl font-display text-brand-espresso mb-1" data-id="element-138">
                MegaPack Master Burger Argentina
              </h3>
              <p className="text-brand-orange font-medium text-sm mb-4" data-id="element-139">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-stone-500 text-sm font-light mb-8 pb-8 border-b border-stone-100" data-id="element-140">
                Ideal para emprendedores que arrancan desde cero en casa,
                quincho o patio.
              </p>

              <div className="mb-8" data-id="element-141">
                <span className="text-stone-400 line-through text-lg block mb-1" data-id="element-142">
                  $65.000
                </span>
                <div className="flex items-baseline gap-1" data-id="element-143">
                  <span className="text-4xl font-display text-brand-espresso" data-id="element-144">
                    $19.990
                  </span>
                  <span className="text-stone-500 font-medium" data-id="element-145">ARS</span>
                </div>
              </div>

              <ButtonCTA href="https://www.novadigital.center/cart/48624582066431:1" variant="outline" className="mt-auto" data-id="element-146">
                QUIERO MI MASTER BURGER ARGENTINA
              </ButtonCTA>
            </div>

            {/* PRO Pack */}
            <div className="bg-brand-cream border-2 border-brand-gold/40 rounded-3xl p-8 shadow-lg shadow-brand-gold/10 flex flex-col relative" data-id="element-147">
              <div className="absolute -top-3 left-8 bg-brand-gold text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full" data-id="element-148">
                Recomendado
              </div>
              <h3 className="text-xl font-display text-brand-espresso mb-1" data-id="element-149">
                Master Burger PRO ⭐
              </h3>
              <p className="text-brand-espresso font-medium text-sm mb-4" data-id="element-150">
                Todo lo anterior +{' '}
                <span className="text-brand-orange" data-id="element-151">
                  Kit Escalado Profesional
                </span>
              </p>
              <p className="text-stone-600 text-sm font-light mb-8 pb-8 border-b border-stone-200" data-id="element-152">
                Ideal para emprendedores que quieren ir del quincho al negocio
                establecido más rápido.
              </p>

              <div className="mb-8" data-id="element-153">
                <span className="text-stone-500 line-through text-lg block mb-1" data-id="element-154">
                  $89.000
                </span>
                <div className="flex items-baseline gap-1" data-id="element-155">
                  <span className="text-4xl font-display text-brand-espresso" data-id="element-156">
                    $27.990
                  </span>
                  <span className="text-brand-gold font-medium" data-id="element-157">ARS</span>
                </div>
              </div>

              <ButtonCTA href="https://www.novadigital.center/cart/48624587014399:1" variant="orange" className="mt-auto" data-id="element-158">
                QUIERO EL MASTER BURGER PRO
              </ButtonCTA>
            </div>
          </div>
        </div>
      </section>

      {/* PRO KIT COMPARISON */}
      <section className="py-24 px-4 bg-stone-50" data-id="element-159">
        <div className="max-w-4xl mx-auto" data-id="element-160">
          <h2 className="text-2xl md:text-3xl font-display text-center text-brand-espresso mb-12" data-id="element-161">
            ¿Qué agrega el Kit Escalado Profesional?
          </h2>

          <div className="bg-white border border-stone-200 rounded-2xl overflow-hidden shadow-sm mb-12" data-id="element-162">
            <div className="overflow-x-auto" data-id="element-163">
              <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-164">
                <thead data-id="element-165">
                  <tr className="bg-brand-cream border-b border-stone-200 text-xs uppercase tracking-wider text-stone-600" data-id="element-166">
                    <th className="p-5 font-semibold w-1/3" data-id="element-167">Situación</th>
                    <th className="p-5 font-semibold w-1/3" data-id="element-168">❌ Sin Kit</th>
                    <th className="p-5 font-semibold w-1/3 text-brand-orange" data-id="element-169">
                      ✅ Con Kit PRO
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm" data-id="element-170">
                  {COMPARISON.map((row, i) => <tr key={i} className="border-b border-stone-100 last:border-0" data-id="element-171">
                      <td className="p-5 text-brand-espresso font-medium" data-id="element-172">
                        {row.sit}
                      </td>
                      <td className="p-5 text-stone-500" data-id="element-173">{row.sin}</td>
                      <td className="p-5 text-brand-espresso font-medium bg-brand-orange/5" data-id="element-174">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* MORE TESTIMONIALS */}
      <section className="py-24 px-4 bg-white border-y border-stone-200" data-id="element-175">
        <div className="max-w-5xl mx-auto" data-id="element-176">
          <h2 className="text-2xl md:text-3xl font-display text-center text-brand-espresso mb-12" data-id="element-177">
            Más emprendedores que ya lo aplican
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-178">
            {TESTIMONIALS_MORE.map((t, i) => <div key={i} className="bg-brand-cream/50 border border-stone-100 p-6 rounded-2xl" data-id="element-179">
                <div className="flex justify-between items-start mb-4" data-id="element-180">
                  <div className="flex text-brand-gold" data-id="element-181">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-182" />)}
                  </div>
                  <span className="text-[10px] font-bold tracking-wider text-stone-400 uppercase" data-id="element-183">
                    {t.pack}
                  </span>
                </div>
                <p className="text-stone-600 font-light mb-6 text-sm leading-relaxed" data-id="element-184">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-185">
                  <div className="w-8 h-8 bg-white border border-stone-200 rounded-full flex items-center justify-center font-display text-xs text-brand-espresso" data-id="element-186">
                    {t.init}
                  </div>
                  <div data-id="element-187">
                    <p className="font-semibold text-brand-espresso text-xs" data-id="element-188">
                      {t.name}
                    </p>
                    <p className="text-[10px] text-stone-400 uppercase tracking-wider" data-id="element-189">
                      {t.loc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-20 px-4 bg-brand-cream border-b border-stone-200 text-brand-espresso text-center" data-id="element-190">
        <div className="max-w-2xl mx-auto bg-white border border-stone-200 rounded-3xl p-10 shadow-sm" data-id="element-191">
          <Shield size={48} className="mx-auto mb-6 text-brand-gold" strokeWidth={1.5} data-id="element-192" />
          <h2 className="text-2xl md:text-3xl font-display mb-4" data-id="element-193">
            Garantía de 7 Días
          </h2>
          <p className="text-lg font-light text-stone-600 mb-6" data-id="element-194">
            Revisá el material y aplicalo en tu emprendimiento. Si no es lo que
            esperabas, solicitás la devolución del 100% sin preguntas.
          </p>
          <p className="text-xs font-semibold uppercase tracking-widest text-stone-400" data-id="element-195">
            Tasa de devoluciones: menor al 1%
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 px-4 bg-stone-50" data-id="element-196">
        <div className="max-w-2xl mx-auto" data-id="element-197">
          <h2 className="text-2xl md:text-3xl font-display text-center text-brand-espresso mb-10" data-id="element-198">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-3" data-id="element-199">
            {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} data-id="element-200" />)}
          </div>
        </div>
      </section>

      {/* COST OF INACTION */}
      <section className="py-24 px-4 bg-white border-t border-stone-200" data-id="element-201">
        <div className="max-w-3xl mx-auto" data-id="element-202">
          <h2 className="text-2xl md:text-3xl font-display text-center text-brand-espresso mb-12" data-id="element-203">
            ¿Cuánto cuesta no tener un sistema?
          </h2>

          <div className="bg-white border border-stone-200 rounded-2xl overflow-hidden shadow-sm mb-12" data-id="element-204">
            <table className="w-full text-left border-collapse" data-id="element-205">
              <thead data-id="element-206">
                <tr className="bg-stone-50 border-b border-stone-200 text-xs uppercase tracking-wider text-stone-500" data-id="element-207">
                  <th className="p-5 font-semibold w-1/2" data-id="element-208">Sin el MegaPack</th>
                  <th className="p-5 font-semibold w-1/2" data-id="element-209">Costo Real</th>
                </tr>
              </thead>
              <tbody className="text-sm" data-id="element-210">
                {COST_INACTION.map((row, i) => <tr key={i} className="border-b border-stone-100 last:border-0" data-id="element-211">
                    <td className="p-5 text-stone-500 flex items-center gap-2" data-id="element-212">
                      <X size={14} className="text-brand-accent flex-shrink-0" data-id="element-213" />{' '}
                      {row.sin}
                    </td>
                    <td className="p-5 text-brand-espresso font-medium" data-id="element-214">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center" data-id="element-215">
            <p className="text-lg font-medium text-brand-espresso mb-2" data-id="element-216">
              El próximo fin de semana puede ser diferente.
            </p>
            <p className="text-stone-500 font-light" data-id="element-217">
              Empezá a operar con un sistema real detrás.
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA & FOOTER */}
      <section className="py-24 px-4 bg-brand-cream text-brand-espresso text-center border-t border-stone-200" data-id="element-218">
        <div className="max-w-3xl mx-auto" data-id="element-219">
          <h2 className="text-3xl font-display mb-8" data-id="element-220">
            Estás a un paso de profesionalizar tu negocio.
          </h2>

          <div className="bg-white border border-stone-200 rounded-2xl p-8 shadow-sm mb-12 max-w-xl mx-auto" data-id="element-221">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-222">
              <div className="text-left" data-id="element-223">
                <h3 className="text-lg font-display text-brand-espresso mb-1" data-id="element-224">
                  Master Burger PRO ⭐
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-225">
                  <span className="text-stone-400 line-through text-sm" data-id="element-226">
                    $89.000
                  </span>
                  <span className="text-2xl font-display text-brand-orange" data-id="element-227">
                    $27.990
                  </span>
                  <span className="text-stone-500 text-xs font-medium" data-id="element-228">
                    ARS
                  </span>
                </div>
              </div>
              <ButtonCTA href="https://www.novadigital.center/cart/48624587014399:1" variant="orange" className="w-full md:w-auto px-8 py-3 text-base" data-id="element-229">
                QUIERO EL MASTER BURGER PRO
              </ButtonCTA>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 text-xs text-stone-500 font-medium uppercase tracking-wider mb-16" data-id="element-230">
            <span className="flex items-center gap-1.5" data-id="element-231">
              <Lock size={14} className="text-brand-gold" data-id="element-232" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-233">
              <Zap size={14} className="text-brand-gold" data-id="element-234" /> Acceso Inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-235">
              <Shield size={14} className="text-brand-gold" data-id="element-236" /> Garantía
            </span>
          </div>
        </div>
      </section>

      <footer className="bg-stone-100 text-stone-500 py-12 px-4 text-center text-xs border-t border-stone-200" data-id="element-237">
        <div className="max-w-4xl mx-auto" data-id="element-238">
          <h4 className="text-sm font-display text-stone-600 mb-2 uppercase tracking-widest" data-id="element-239">
            Master Burger Argentina™
          </h4>
          <p className="mb-8 font-light" data-id="element-240">
            El sistema integral para hamburgueserías caseras.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-8 uppercase tracking-wider" data-id="element-241">
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-242">
              Soporte
            </a>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-243">
              Instagram
            </a>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-244">
              Sitio Web
            </a>
          </div>

          <p data-id="element-245">© Nova Digital™ 2024 — Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>;
}